<footer id="footer" class="footer">
  <div class="container">
    <div class="copyright">
      &copy; Copyright. All Rights Reserved
    </div>
  </div>
</footer>